import React from 'react';
import HeaderFillTop from '../HeaderFillTop';
import RightSideSectionWrapper from '../RightSideSectionWrapper';
import SecurityOptionalCompo from './SecurityOptionalCompo';

export default function SecurityOptional() {
  return (
    <React.Fragment>
      <div>
        <div className="">
          <HeaderFillTop
            title={'Security Optional Settings'}
            extraPills={<></>}
            extra={
              <>
                {/* <span className="flex gap-2 items-center">
                  <Tooltip
                    title={!toggle ? 'Enable Edit' : 'Disable Edit'}
                    placement={'left'}
                  >
                    <span className="flex">
                      <ToogleSwitch value={toggle} toggleValue={toggleValue} />
                    </span>
                  </Tooltip>
                </span> */}
              </>
            }
          />
        </div>
        <RightSideSectionWrapper>
          <section>
            <div className="container-fluid">
              <div className="p-3">
                <SecurityOptionalCompo />
              </div>
            </div>
          </section>
        </RightSideSectionWrapper>
      </div>
    </React.Fragment>
  );
}
